<div class="text-center backgr-login">
    <router-outlet></router-outlet>
</div>